/**
 * Search Brandfetch Tool Schema
 *
 * Search for company logos and brand colors via Brandfetch API.
 * Uses camelCase params as per Notion spec.
 */
import { z } from "zod";
// ═══════════════════════════════════════════════════════════════════════════
// PARAMS SCHEMA
// ═══════════════════════════════════════════════════════════════════════════
/**
 * Asset types that can be searched
 */
export const AssetTypeEnum = z.enum(["logo", "brand_colors"]);
/**
 * Search Brandfetch parameters
 */
export const SearchBrandfetchParamsSchema = z.object({
    uiDescription: z.string()
        .describe("Brief description (max ~15 words) of what this tool call is attempting."),
    query: z.string()
        .min(1, "Query cannot be empty")
        .describe("Company name or domain (e.g., 'Microsoft' or 'microsoft.com')"),
    assetTypes: z.array(AssetTypeEnum)
        .min(1, "At least one asset type is required")
        .describe("Asset types to search for: ['logo'], ['brand_colors'], or both"),
});
